import type { SVGProps } from "react";

export function IconWhiteLiquidDollar(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <path
        d="M19.5 14.5C19.5 14.0055 19.2947 13.5222 18.9101 13.1111C18.5256 12.7 17.9789 12.3795 17.3394 12.1903C16.6999 12.0011 15.9961 11.9516 15.3172 12.048C14.6383 12.1445 14.0146 12.3826 13.5251 12.7322C13.0356 13.0819 12.7023 13.5273 12.5673 14.0123C12.4322 14.4972 12.5015 14.9999 12.7664 15.4567C13.0313 15.9135 13.4799 16.304 14.0555 16.5787C14.6311 16.8534 15.3078 17 16 17C16.6922 17 17.3689 17.1466 17.9445 17.4213C18.5201 17.696 18.9687 18.0865 19.2336 18.5433C19.4985 19.0001 19.5678 19.5028 19.4327 19.9877C19.2977 20.4727 18.9644 20.9181 18.4749 21.2678C17.9854 21.6174 17.3618 21.8555 16.6828 21.952C16.0039 22.0484 15.3002 21.9989 14.6606 21.8097C14.0211 21.6205 13.4744 21.3 13.0899 20.8889C12.7053 20.4778 12.5 19.9945 12.5 19.5"
        stroke="#23232C"
        strokeWidth="1.5"
      />
      <path
        d="M16 12V11M16 23V22"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 8.75V28.75H28.75V8.75V3.75734V3.5H27.0499L25.9873 4.86616C25.1902 5.89099 23.6604 5.94591 22.7919 4.98088L22.6359 4.80757C21.2375 3.25383 18.7794 3.32523 17.4735 4.95751C16.7181 5.90178 15.2819 5.90178 14.5265 4.95751L14.4735 4.89128C13.1872 3.28337 10.7888 3.15053 9.33279 4.60656L9.07938 4.85996C8.06396 5.87538 6.37341 5.70798 5.57685 4.51314L4.90143 3.5H3.25V3.72703V8.75ZM27.1713 5.78707L27.25 5.68591V27.25H4.75V5.87074C6.18076 7.36294 8.6177 7.44296 10.14 5.92062L10.3934 5.66722C11.2173 4.84335 12.5744 4.91852 13.3022 5.82832L13.3552 5.89456C14.7111 7.58944 17.2889 7.58944 18.6448 5.89456C19.3723 4.98516 20.7419 4.94538 21.5209 5.81102L21.6769 5.98433C23.1703 7.64366 25.8008 7.54922 27.1713 5.78707Z"
        fill="#23232C"
      />
    </svg>
  );
}
